import React from 'react';
import {Navigate, useParams} from 'react-router-dom';

export const LayoutRedirect = (): JSX.Element => {
    const {jobId, roomId} = useParams();

    return (
        <Navigate to={`/v2/job/${jobId}/room/${roomId}/dashboard`} replace />
    );
};

export default LayoutRedirect;
